import { Http } from "@angular/http";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import { VehicleAttributeModel } from "./../../vehicle-attribute/models/vehicleattribute.model";
import { VehicleAttributeService } from "./../../vehicle-attribute/models/vehicleattribute.service";
import { BookingOverviewList } from "./../../booking/models/booking-overviewlist.model";
import {
  IKeyValueInterface,
  Marker,
  PermissionType,
  Permission,
  Entity
} from "./../../shared/config";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild, Input } from "@angular/core";
import { NgForm } from "@angular/forms";
import { VehicleModel } from "../models/vehicle.model";
import { VehicleService } from "../models/vehicle.service";
import { CompanyModel } from "../../company/models/company.model";
import { CompanyService } from "../../company/models/company.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  DataListModel,
  RoleLevel
} from "../../shared/config";
import { Location } from "@angular/common";
import { FileUploader } from "ng2-file-upload";
import { PrePostTripQuestionComponent } from "../../pre-post-trip-question/components/pre-post-trip-question.component";
import { BasePermissionModel } from "../../shared/models/base-permission-model";

@Component({
  selector: "wego-vehicle-update",
  template: require('../views/vehicle-update.component.html'),
  providers: [VehicleService, CompanyService, VehicleAttributeService]
})
export class VehicleUpdateComponent implements OnInit, OnDestroy {
  basePermissionModel: BasePermissionModel;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  private vehicleMasterHashId: string;
  private sub: any;
  // private isTowbar = false;
  // private isAirco = false;
  public isAuthorizedForPrePostTrip: boolean;
  submitted = false;
  DataListModel: DataListModel;
  model: VehicleModel;
  apiResponse: IAPIResponse;
  vehicleList: VehicleModel[];
  VTSVehicleList: VehicleModel[];
  companyList: any;
  vehicleAttributeList: VehicleAttributeModel[] = [];
  errorModel: IKeyValueInterface[];
  bookingList: BookingOverviewList[];
  errorMessage: string;
  message: string;
  instanceList: any;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlVehicleList: string;
  errorGeoLocationAddress: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  flatePickerApkExiprationDate: FlatPickrModel;
  isLoading: boolean;
  fuelTypeList: any;
  bodyStyleList: any;
  vehicleClassList: any;
  pricingCategoryList: any;
  vehicletypeList: any;
  licenseList: any;
  roleLevel = RoleLevel;
  //WEGO2DEV-325(Settings for Dashboard statuses)
  //timeIntervalList : any;
  //bookedBeforeTimeIntervalList : any;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  public headers: any = this.authService.GetHeaderForFile();
  public uploader: FileUploader = new FileUploader({
    url: WeGoConfig.API_POST_VEHICLE_DETAIL,
    headers: this.headers
  });
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  public filePath: string;
  public language: string = 'en';
  markerInfo: Marker;
  urlCompanyInformation: string;
  locationModelField: string;
  vtsConfirmMsg: string;
  LblWarning: string;
  isCloneMode: boolean;
  public fileListQuer: string[] = [];

  @ViewChild("affectedbookingModal") public affectedbookingModal: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("warningPopup") public warningPopup: any;
  @ViewChild("geoLocationModal") public geoLocationModal: any;
  @ViewChild("prePostTripQuestionSection")
  public prePostTripQuestionSection: PrePostTripQuestionComponent;

  @ViewChild("logoFile") public logoFile: any;

  constructor(
    private vehicleService: VehicleService,
    private vehicleAttributeSerive: VehicleAttributeService,
    private companyService: CompanyService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private http: Http,
    private locationService: Location
  ) { }

  OnLicencePlatChange(newValue: any) {
    let ltag: any;
    ltag = this.formatLicenceTag(newValue);
    console.log(newValue, this.model.licenceTag);
    this.model.licenceTag = ltag;
  }

  // eventHandler(event: any) {
  //   console.log(event, event.keyCode, event.keyIdentifier);
  //   var regex = new RegExp("^[0-9a-zA-Z \b]+$");
  //   var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //   if (!regex.test(key)) {
  //     event.preventDefault();
  //     return false;
  //   }
  // }

  // onBlurLicenceTag() {
  //   var regex = new RegExp("/^[a-z\d]+[-a-z\d]+[a-z\d]+$/");
  //   if (regex.test(this.model.licenceTag)) {
  //     this.model.licenceTag = '';
  //   }
  // }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (fileItem: any) => {
      if (this.uploader.queue.length > 1) {
        this.uploader.queue.forEach(element => {
          element.remove();
        });
      }
    };
    this.pricingCategoryList = [
      {
        Key: this.translate.instant("LblSelectPricingCatagory"),
        Value: ""
      },
      {
        Key: "A",
        Value: "A"
      },
      {
        Key: "B",
        Value: "B"
      },
      {
        Key: "C",
        Value: "C"
      },
      {
        Key: "D",
        Value: "D"
      },
      {
        Key: "E",
        Value: "E"
      },
      {
        Key: "F",
        Value: "F"
      },
      {
        Key: "G",
        Value: "G"
      },
      {
        Key: "H",
        Value: "H"
      }
    ];

    this.vehicletypeList = [
      {
        Key: this.translate.instant("LblSelectVehicletype"),
        Value: ""
      },
      {
        Key: "CAR",
        Value: "C"
      }, {
        Key: "BIKE",
        Value: "B"
      }, {
        Key: "SCOOTER",
        Value: "S"
      }, {
        Key: "OTHER",
        Value: "O"
      }
    ];

    
    this.licenseList = [ 
      {
        Key: "AM",
        Value: "AM"
      },
      {
        Key: "A",
        Value: "A"
      },
      {
        Key: "B",
        Value: "B"
      },
      {
        Key: "C",
        Value: "C"
      },
      {
        Key: "C1",
        Value: "C1"
      },
      {
        Key: "D",
        Value: "D"
      },
      {
        Key: "T",
        Value: "T"
      }
    ];

    this.fuelTypeList = [
      {
        Key: this.translate.instant("LblSelectFuelType"),
        Value: ""
      },
      {
        Key: "PETROL (E5/E10)",
        Value: "PETROL (E5/E10)"
      },
      {
        Key: "DIESEL (B7/B10)",
        Value: "DIESEL (B7/B10)"
      },
      {
        Key: "GAS (LPG)",
        Value: "GAS (LPG)"
      },
      {
        Key: "ELECTRIC (EV)",
        Value: "ELECTRIC (EV)"
      }, 
      { 
      Key: "HYBRID (PHEV)", 
      Value: "HYBRID (PHEV)" 
      }      
    ];

    this.bodyStyleList = [
      {
        Key: this.translate.instant("LblSelectBodyStyle"),
        Value: ""
      },
      {
        Key: "HATCHBACK",
        Value: "HATCHBACK"
      },
      {
        Key: "SEDAN",
        Value: "SEDAN"
      },
      {
        Key: "CONVERTIBLE",
        Value: "CONVERTIBLE"
      },
      {
        Key: "WAGON",
        Value: "WAGON"
      }
    ];

    this.vehicleClassList = [
      {
        Key: this.translate.instant("LblSelectVehicleClass"),
        Value: ""
      },
      {
        Key: "MINICOMPACT",
        Value: "MINICOMPACT"
      },
      {
        Key: "SUBCOMPACT",
        Value: "SUBCOMPACT"
      },
      {
        Key: "COMPACT",
        Value: "COMPACT"
      },
      {
        Key: "SUV",
        Value: "SUV"
      },
      {
        Key: "VAN",
        Value: "VAN"
      }
    ];

    //WEGO2DEV-325(Settings for Dashboard statuses)
    // this.timeIntervalList = [
    //   {
    //     Key: this.translate.instant('LblSelectTimeInterval'),
    //     Value: ''
    //   },
    //   {
    //     Key: this.translate.instant('LblHour'),
    //     Value: 'HOUR'
    //   },
    //   {
    //     Key: this.translate.instant('LblDay'),
    //     Value: 'DAY'
    //   },
    //   {
    //     Key: this.translate.instant('LblWeek'),
    //     Value: 'WEEK'
    //   },
    //   {
    //     Key: this.translate.instant('LblMonth'),
    //     Value: 'MONTH'
    //   }
    // ];
    // this.bookedBeforeTimeIntervalList = [
    //   {
    //     Key: this.translate.instant('LblSelectBookedBeforeInterval'),
    //     Value: ''
    //   },
    //   {
    //     Key: this.translate.instant('LblHour'),
    //     Value: 'HOUR'
    //   },
    //   {
    //     Key: this.translate.instant('LblDay'),
    //     Value: 'DAY'
    //   },
    //   {
    //     Key: this.translate.instant('LblWeek'),
    //     Value: 'WEEK'
    //   },
    //   {
    //     Key: this.translate.instant('LblMonth'),
    //     Value: 'MONTH'
    //   }
    // ];

    this.module = this.translate.instant("LblVehicle");
    this.vtsConfirmMsg = this.translate.instant(
      "LblLocationDataExchangeNotAssign"
    );
    this.LblWarning = this.translate.instant("LblWarning");
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      "licenceTag",
      "bookingReferenceID",
      "driver",
      "translatedBookingStatus",
      "translatedBookingType"
    ];
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatePickerApkExiprationDate = this.SetApkExirationFlatPickrConfig();
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlVehicleList = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_LIST
    );
    this.urlCompanyInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_COMPANY_UPDATE
    );
    this.sub = this.activeRoute.params.subscribe(params => {
      this.vehicleMasterHashId = params["id"] || "";
      this.isCloneMode = params["isCloneMode"] || "";
    });
    this.model = new VehicleModel();
    if (this.authService.GetHighestRoleLevel() == this.roleLevel.WeGo) {
      this.GetVTSVehicleList();
    } else {
      this.GetVehicleDetails();
    }
  }

  ngAfterViewInit() {
    // viewChild is set after the view has been initialized
    // this.prePostTripQuestionSection.GetPrePostTripQuestionList(
    //   null,
    //   null,
    //   null,
    //   this.vehicleMasterHashId
    // );
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }
  private SetApkExirationFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }
  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetBookingOverList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetBookingOverList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetBookingOverList();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }
  public beforeUpload($event: any): void {
    this.uploader.clearQueue();
  }

  onSubmit(forms: any) {
    if (
      this.model.locationDataExchangeHashId == "" &&
      this.authService.GetHighestRoleLevel() == this.roleLevel.WeGo
    ) {
      this.warningPopup.show(false);
    } else {
      this.UpdateVehicle();
    }
  }
  
  public ClearFileInput() {
    console.log(this.logoFile);
    if (this.logoFile.nativeElement) {
      console.log(this.logoFile.nativeElement.value);
      this.logoFile.nativeElement.value = "";
      this.uploader.clearQueue();
    }
  }

  public UpdateVehicle() {
    this.model.attributeList = this.vehicleAttributeList
      .filter(x => x.isChecked)
      .map(x => x.vehicleAttributeHashId);
    if (this.uploader.queue && this.uploader.queue.length > 0) {
      this.vehicleService
        .GetBookingOverviewList(this.model, this.DataListModel)
        .subscribe(
          (res: any) => {
            if (res.error) {
              this.errorModel = res.error;
            } else if (res.totalRecords == 0) {
              this.uploader.onBuildItemForm = (fileItem: any, Form: any) => {
                console.log(this.model);
                // console.log(JSON.stringify(this.model));
                Form.append("vehicleFormData", JSON.stringify(this.model));

                console.log("form built");

              };
              var apiresponse: any;
              var status: any;
              this.uploader.onCompleteItem = (
                item: any,
                response: any,
                status: any,
                headers: any
              ) => {
                apiresponse = JSON.parse(response);
                console.log(apiresponse.error);

                if (status == 200) {
                  if (apiresponse.data == true) {
                    this.popupMsg = this.isEditMode
                      ? this.translate.instant("LblRecordUpdatedSuccess", [
                        this.module
                      ])
                      : this.translate.instant("LblRecordAddedSuccess", [
                        this.module
                      ]);
                    this.ShowSuccessPopup();
                  } else {
                    this.errorModel = apiresponse.error;
                    this.ClearFileInput();
                  }
                }
              };
              this.uploader.uploadAll();
            } else if (res.totalRecords > 0) {
              this.bookingList = res.data;
              this.DataListModel.totalItems = res.totalRecords;
              this.DataListModel.infoMessage = res.error;
              this.affectedbookingModal.show();
            }
          },
          (error: any) => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    } else {
      this.model.attributeList = this.vehicleAttributeList
        .filter(x => x.isChecked)
        .map(x => x.vehicleAttributeHashId);
      this.vehicleService
        .GetBookingOverviewList(this.model, this.DataListModel)
        .subscribe(
          (res: any) => {
            if (res.error) {
              this.errorModel = res.error;
            } else if (res.totalRecords == 0) {
              this.vehicleService
                .UpdateVehicleMaster(
                  "vehicleFormData=" +
                  encodeURIComponent(JSON.stringify(this.model))
                )
                .subscribe(
                  (res: any) => {
                    if (res.data) {
                      this.popupMsg = this.isEditMode
                        ? this.translate.instant("LblRecordUpdatedSuccess", [
                          this.module
                        ])
                        : this.translate.instant("LblRecordAddedSuccess", [
                          this.module
                        ]);
                      this.ShowSuccessPopup();
                    } else {
                      this.errorModel = res.error;
                    }
                  },
                  (error: any) => {
                    this.errorMessage = this.authService.HandleErrorStatusCode(
                      error
                    );
                    this.isLoading = false;
                  }
                );
            } else if (res.totalRecords > 0) {
              this.bookingList = res.data;
              this.DataListModel.totalItems = res.totalRecords;
              this.DataListModel.infoMessage = res.error;
              this.affectedbookingModal.show();
            }
          },
          (error: any) => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }
  
  public OnChangeVin() { 
    this.model.vin = this.model.vin.toUpperCase();
    var vnumber = this.model.vin;
 
    let isValid = this.ValidateVin(vnumber);
    if (vnumber.length == 0) isValid = true;

    if(!isValid) {
      alert(this.translate.instant("LblWrongVinNumber"));
    }
  }

  public ValidateVin(vin: string) : boolean {
    return this.validate(vin);
  }
      
  public Transliterate(c: string) : number {
    return '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(c) % 10;
  }

  public getCheckDigit(vin: string) : string {
    var map = '0123456789X';
    var weights = '8765432X098765432';
    var sum = 0;
    for (var i = 0; i < 17; ++i)
    sum += this.Transliterate(vin[i]) * map.indexOf(weights[i]);
    return map[sum % 11];
  }
  
  public validate(vin: string): boolean {
    if (vin.length !== 17) return false;
    return this.getCheckDigit(vin) === vin[8];
  }

  public formatLicenceTag(newVal: string) {
    var outputString = "";
    var chars: any = newVal.replace(/-/g, "").split("");
    if (!(chars.length > 0)) return outputString;
    if (chars.length == 1) return chars[0];
    for (let i = 1; i < chars.length; i++) {
      outputString += chars[i - 1];
      if (chars[i - 1] == "-" || chars[i] == "-") {
        continue;
      }
      if (isNaN(chars[i - 1]) != isNaN(chars[i])) {
        outputString += "-";
      }
      if (i == chars.length - 1) {
        outputString += chars[i];
      }
    }
    console.log(outputString);
    return outputString;
  }
  public GetBookingOverList() {
    this.isLoading = true;
    this.vehicleService
      .GetBookingOverviewList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          this.bookingList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.affectedbookingModal.show();
          this.isLoading = false;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public AddNewVehicle(formData: any) {
    this.vehicleService
      .GetBookingOverviewList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res.error) {
            this.errorModel = res.error;
          } else if (res.totalRecords == 0) {
            this.vehicleService.AddNewVehicle(formData).subscribe(
              (anv: any) => {
                if (anv.data) {
                  this.popupMsg = this.isEditMode
                    ? this.translate.instant("LblRecordUpdatedSuccess", [
                      this.module
                    ])
                    : this.translate.instant("LblRecordAddedSuccess", [
                      this.module
                    ]);
                  this.ShowSuccessPopup();
                } else {
                  this.errorModel = anv.error;
                }
              },
              (adverror: any) => {
                this.errorMessage = this.authService.HandleErrorStatusCode(
                  adverror
                );
                this.isLoading = false;
              }
            );
          } else if (res.totalRecords > 0) {
            this.bookingList = res.data;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.affectedbookingModal.show();
          }
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public OnCancel(): void {
    this.affectedbookingModal.hide();
    this.router.navigate([this.urlVehicleList]);
  }

  public OnConfirm(): void {
    this.affectedbookingModal.hide();
    // this.vehicleService.AddNewVehicle(this.model)
    //   .subscribe(
    //   res => {
    //     if (res.data) {
    //       this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant

    // ('LblRecordAddedSuccess', [this.module]);
    //       this.ShowSuccessPopup();
    //     }
    //     else {
    //       this.errorModel = res.error;
    //     }
    //   },
    //   error => {
    //     this.errorMessage = this.authService.HandleErrorStatusCode(error);
    //     this.isLoading = false;
    //   });
    if (this.uploader.queue && this.uploader.queue.length > 0) {
      this.model.attributeList = this.vehicleAttributeList
        .filter(x => x.isChecked)
        .map(x => x.vehicleAttributeHashId);
      this.uploader.onBuildItemForm = (fileItem: any, Form: any) => {
        Form.append("vehicleFormData", JSON.stringify(this.model));
      };
      var apiresponse: any;
      var status: any;
      this.uploader.onCompleteItem = (
        item: any,
        confirmResponse: any,
        status: any,
        headers: any
      ) => {
        apiresponse = JSON.parse(confirmResponse);
        console.log(apiresponse.error);

        if (status == 200) {
          if (apiresponse.data == true) {
            this.popupMsg = this.isEditMode
              ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
              : this.translate.instant("LblRecordAddedSuccess", [this.module]);
            this.ShowSuccessPopup();
          } else {
            this.errorModel = apiresponse.error;
          }
        }
      };
      this.uploader.uploadAll();
    } else {
      this.model.attributeList = this.vehicleAttributeList
        .filter(x => x.isChecked)
        .map(x => x.vehicleAttributeHashId);
      this.vehicleService
        .UpdateVehicleMaster("vehicleFormData=" + encodeURIComponent(JSON.stringify(this.model)))
        .subscribe(
          veh => {
            if (veh.data) {
              this.popupMsg = this.isEditMode
                ? this.translate.instant("LblRecordUpdatedSuccess", [
                  this.module
                ])
                : this.translate.instant("LblRecordAddedSuccess", [
                  this.module
                ]);
              this.ShowSuccessPopup();
            } else {
              this.errorModel = veh.error;
            }
          },
          (error: any) => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }
  public GetCompanyList() {
    let permissionType = "";
    if (this.isEditMode) {
      permissionType = PermissionType.EDIT;
    } else {
      permissionType = PermissionType.INSERT;
    }

    this.companyService
      .GetCompanyListDropdownForAddUpdatePage("Vehicle", permissionType)
      .subscribe(
        (res: any) => {
          this.apiResponse = res;
          this.companyList = res.data;
          // this.model.pricingCategory = this.pricingCategoryList.length > 0 ? this.pricingCategoryList[0].Value : '';
          // this.model.bodyStyle = this.bodyStyleList.length > 0 ? this.bodyStyleList[0].Value : '';
          // this.model.fuelType = this.fuelTypeList.length > 0 ? this.fuelTypeList[0].Value : '';
          // this.model.vehicleClass = this.vehicleClassList.length > 0 ? this.vehicleClassList[0].Value : '';
          // this.isLoading = false;
          this.IsAuthorizedForPrePostTripQuestion();
          console.log(this.model);
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          // this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  public GetVehicleAttributeList() {
    this.vehicleAttributeSerive.GetVehicleAttributeList().subscribe(
      (res: any) => {
        this.apiResponse = res;
        this.vehicleAttributeList = res.data;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => this.GetVehicleDetails()
    );
  }

  public GetVehicleAttributeForCompany(ownerCompanyHashID: any) {
    this.vehicleAttributeSerive
      .GetVehicleAttributeForCompany(ownerCompanyHashID)
      .subscribe(
        (res: any) => {
          this.apiResponse = res;
          this.vehicleAttributeList = res.data;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        },
        () => {
          if (this.isEditMode || this.isCloneMode) {
            this.vehicleAttributeList
              .filter(
                x =>
                  this.model.attributeList &&
                  this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
                  -1
              )
              .forEach(x => (x.isChecked = true));
          }
        }
      );
  }
  public GetVehicleDetails() {
    this.isLoading = true;
    if (this.vehicleMasterHashId != "") {
      this.isEditMode = true;
      this.vehicleService
        .GetVehicleByHashId(this.vehicleMasterHashId, true && (!this.isCloneMode))
        .subscribe(
          res => {
            this.model = res.data;
            this.language = this.model.instanceLanguage;
            if (this.isCloneMode) {
              this.isEditMode = false;
              this.model.vehicleMasterHashId = "";
              this.model.licenceTag = "";
              this.model.locationDataExchangeHashId = "";
            }
            // if (this.model.vehicleGeoLocationAddress) {
            //   this.markerInfo = {
            //     draggable: false,
            //     lat: this.model.vehicleGeoLocationLatitude,
            //     lng: this.model.vehicleGeoLocationLongitude,
            //     label: this.model.vehicleGeoLocationAddress,
            //     isOpen: true
            //   }
            // }
            this.vehicleAttributeList
              .filter(
                x =>
                  this.model.attributeList &&
                  this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
                  -1
              )
              .forEach(x => (x.isChecked = true));

            this.GetVehicleAttributeForCompany(this.model.ownerCompanyHashID);
            this.GetCompanyList();
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    } else {
      this.isEditMode = false;
      this.model.pricingCategory =
        this.pricingCategoryList.length > 0
          ? this.pricingCategoryList[0].Value
          : "";
      this.model.vehicletypeList =
        this.vehicletypeList.length > 0
          ? this.vehicletypeList[3].Value
          : "";
      this.model.bodyStyle =
        this.bodyStyleList.length > 0 ? this.bodyStyleList[0].Value : "";
      this.model.fuelType =
        this.fuelTypeList.length > 0 ? this.fuelTypeList[0].Value : "";
      this.model.vehicleClass =
        this.vehicleClassList.length > 0 ? this.vehicleClassList[0].Value : "";

      this.GetCompanyList();
    }
    if (this.isCloneMode) {
      this.breadCrumbTitle = this.translate.instant("LblCloneVehicle", [
        this.module
      ]);
    } else {
      this.breadCrumbTitle = this.isEditMode
        ? this.translate.instant("LblEditPage", [this.module])
        : this.translate.instant("LblAddPage", [this.module]);
    }
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  public Geofence() {
    this.companyService
      .IsGeofenceEnables(this.model.ownerCompanyHashID)
      .subscribe(res => {
        this.model.isGefenceEnabled = res.data;
      });
  }

  public GetLocationMode() {
    this.companyService
      .GetLocationMode(this.model.ownerCompanyHashID)
      .subscribe(
        res => {
          this.model.isHomeLocationEnabled = res.data;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  onChangeSelectedCompany(selectedField: any) {
    //this.model.ownerCompanyHashID = selectedField;
    this.IsAuthorizedForPrePostTripQuestion();
    this.model.attributeList = [];
    this.GetVehicleAttributeForCompany(this.model.ownerCompanyHashID);
    this.Geofence();
    this.GetLocationMode();
    this.GetInstanceLaguage();
  }

  public GetInstanceLaguage() {
    this.companyService
      .GetInstanceLanguage(this.model.ownerCompanyHashID)
      .subscribe(
        res => {
          this.language = res.data;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GeofenceLocation() {
    this.locationModelField = "geofence";
    this.geoLocationModal.show(
      this.model.geofenceAttributeModel.address,
      this.model.geofenceAttributeModel.latitude,
      this.model.geofenceAttributeModel.longitude
    );
  }

  public SearchHomeAddress() {
    this.locationModelField = "home";
    this.geoLocationModal.show(
      this.model.homeLocationModel.address,
      this.model.homeLocationModel.latitude,
      this.model.homeLocationModel.longitude
    );
  }

  public onConfirm($event: any) {
    if (this.locationModelField == "home") {
      this.model.homeLocationModel.address = $event.address;
      this.model.homeLocationModel.latitude = $event.lat;
      this.model.homeLocationModel.longitude = $event.long;
    } else {
      this.model.geofenceAttributeModel.address = $event.address;
      this.model.geofenceAttributeModel.latitude = $event.lat;
      this.model.geofenceAttributeModel.longitude = $event.long;
    }
  }

  public ResetLocationField(locationModelField: string) {
    if (locationModelField == "home") {
      this.model.homeLocationModel.address = "";
      this.model.homeLocationModel.latitude = "0";
      this.model.homeLocationModel.longitude = "0";
    } else {
      this.model.geofenceAttributeModel.address = "";
      this.model.geofenceAttributeModel.latitude = "0";
      this.model.geofenceAttributeModel.longitude = "0";
    }
  }

  public GetVTSVehicleList() {
    this.vehicleService.GetVTSVehicleList().subscribe(
      (res: any) => {
        this.apiResponse = res;
        this.VTSVehicleList = res.data;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => this.GetVehicleDetails()
    );
  }

  public SetLowBatteryFlag() {
    if (
      this.model.lowBatteryFlagRaised != null &&
      this.model.lowBatteryFlagRaised != ""
    ) {
      this.model.lowBatteryFlagClear =
        this.model.lowBatteryFlagClear == null ||
          this.model.lowBatteryFlagClear == ""
          ? "0"
          : this.model.lowBatteryFlagClear;
    } else {
      this.model.lowBatteryFlagClear =
        this.model.lowBatteryFlagClear == null ||
          this.model.lowBatteryFlagClear == ""
          ? ""
          : this.model.lowBatteryFlagClear;
    }
  }

  public UpdateVTSData() {
    // let vtsData = this.VTSVehicleList.find(x => x.locationDataExchangeHashId == this.model.locationDataExchangeHashId);
    // if (vtsData) {
    //   this.model.brand = vtsData.brand;
    //   this.model.type = vtsData.type;
    //   this.model.color = vtsData.color;
    // }
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  public GroupByCategory() {
    let prop = "vehicleAttributeCategoryName";
    if (
      this.vehicleAttributeList == null ||
      this.vehicleAttributeList.length == 0
    )
      return null;
    else
      return this.vehicleAttributeList.reduce(function (groups, item) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }

  public OnPrePostTripQuestionSetting($event: any) {
    this.model.customTripQuestionList = $event.customTripQuestionList;
  }

  public IsAuthorizedForPrePostTripQuestion() {
    let primaryPermissionType: string;
    if (this.vehicleMasterHashId != "") {
      primaryPermissionType = PermissionType.EDIT;
    } else {
      primaryPermissionType = PermissionType.INSERT;
    }
    this.authService
      .IsAuthorizedForPrePostQuestion(
        Permission.PR_VEHICLES_OVERVIEW,
        primaryPermissionType,
        Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE,
        PermissionType.VIEW,
        Entity.COMPANY,
        this.model.ownerCompanyHashID
      )
      .subscribe(
        res => {
          this.isAuthorizedForPrePostTrip = res.data.view;
          this.basePermissionModel = res.data;
          console.log(this.prePostTripQuestionSection);
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        },
        () => {
          setTimeout(() => {
            if (this.isAuthorizedForPrePostTrip && this.isEditMode) {
              this.prePostTripQuestionSection.GetPrePostTripQuestionList(
                null,
                null,
                null,
                this.vehicleMasterHashId,
                this.basePermissionModel,
                !this.vehicleMasterHashId
              );
            }
          }, 1000);
        }
      );
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/components/vehicle-update.component.ts